import { DendromapLoader } from '@repo/ui/components/dendromap-loader';
import { lazy, Suspense } from 'react';
import { DashboardLayout } from '@repo/ui/components/dashboard-layout';

const DashboardOverview = lazy(() =>
  import('@repo/ui/features/dashboard/dashboard-overview').then((mod) => ({ default: mod.DashboardOverview })),
);

export default function DashboardPage() {
  return (

    <Suspense fallback={<DendromapLoader message="Chargement du tableau de bord..." />}>
      <DashboardOverview />
    </Suspense>

  );
}

